import React, { useState, useEffect, useRef } from 'react'
import './therapy.css'
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { APIURL } from "../../Global";
import AddTherapy from './AddTherapy';
import ShowHistory from './ShowHistory';
import "simplebar-react/dist/simplebar.min.css";
import SimpleBar from "simplebar-react";
import moment from 'moment';
import { useAlert } from 'react-alert';
import { Flex } from 'antd';

function Therapy({ id, appt_status, mobile, inpatient }) {
    const [data, setData] = useState('')
    const [selected, setSelected] = useState("current")
    const [show, setShow] = useState(false)
    const userData = JSON.parse(sessionStorage.getItem("logindatas"));
    const name = userData.name;
    const alert = useAlert();
    const today = moment(new Date()).format('YYYY-MM-DD')
    const navigate = useNavigate()
    const [customTherapy, setCustomTherapy] = useState('');
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [selectedTherapies, setSelectedTherapies] = useState(
        data.therapy_type ?
            (typeof data.therapy_type === 'string' ?
                data.therapy_type.split(',').map(item => item.trim()) :
                Array.isArray(data.therapy_type) ? data.therapy_type : [])
            : []
    );
    const [customTherapyType, setCustomTherapyType] = useState('');
    const [showCustomTypeInput, setShowCustomTypeInput] = useState(false);

    const therapyOptions = [
        { value: "movement_exercise", label: "Movement and Exercise" },
        { value: "manual_therapy", label: "Manual Therapy" },
        { value: "ultrasound", label: "Ultrasound" },
        { value: "dry_needling", label: "Dry Needling" },
        { value: "traction", label: "Traction" },
        { value: "hydrotherapy", label: "Hydrotherapy" }
    ];

    const therapyTypeOptions = [
        { value: "acute", label: "Acute" },
        { value: "chronic", label: "Chronic" },
        { value: "preventive", label: "Preventive" },
        { value: "rehabilitation", label: "Rehabilitation" },
        { value: "maintenance", label: "Maintenance" }
    ];

    const handleTherapySelection = (value) => {
        let updatedTherapies;

        if (selectedTherapies.includes(value)) {
            // Remove if already selected
            updatedTherapies = selectedTherapies.filter(therapy => therapy !== value);
        } else {
            // Add if not selected
            updatedTherapies = [...selectedTherapies, value];
        }

        setSelectedTherapies(updatedTherapies);

        // Update the data state with comma-separated string
        setData((currentState) => ({
            ...currentState,
            therapy_type: updatedTherapies.join(', ')
        }));
    };

    const handleCustomTherapyAdd = () => {
        if (customTherapy.trim() && !selectedTherapies.includes(customTherapy.trim())) {
            const updatedTherapies = [...selectedTherapies, customTherapy.trim()];
            setSelectedTherapies(updatedTherapies);

            // Update the data state with comma-separated string
            setData((currentState) => ({
                ...currentState,
                therapy_type: updatedTherapies.join(', ')
            }));

            setCustomTherapy('');
            setShowCustomInput(false);
        }
    };

    const removeTherapy = (therapyToRemove) => {
        const updatedTherapies = selectedTherapies.filter(therapy => therapy !== therapyToRemove);
        setSelectedTherapies(updatedTherapies);

        // Update the data state with comma-separated string
        setData((currentState) => ({
            ...currentState,
            therapy_type: updatedTherapies.join(', ')
        }));
    };

    const getDisplayLabel = (value) => {
        const option = therapyOptions.find(opt => opt.value === value);
        return option ? option.label : value;
    };

    const getTypeDisplayLabel = (value) => {
        const option = therapyTypeOptions.find(opt => opt.value === value);
        return option ? option.label : value;
    };

    useEffect(() => {
        therapy()
    }, [])

    // Update selected items when data changes
    useEffect(() => {
        if (data) {
            const therapies = data.therapy_type ?
                (typeof data.therapy_type === 'string' ?
                    data.therapy_type.split(',').map(item => item.trim()) :
                    Array.isArray(data.therapy_type) ? data.therapy_type : [])
                : [];
            setSelectedTherapies(therapies);
        }
    }, [data]);

    const therapy = async () => {
        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");

        const date = moment(new Date()).format('YYYY-MM-DD')
        const patient_id = id

        try {
            const currentRes = await axios.get(`${APIURL}/api/v1/patient/therapy-consultation/?current=True&date=${date}&patient_id=${patient_id}`, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                },
            });

            if (currentRes.data.status === "success") {
                setData(currentRes.data.message);
            } else {
                setData('')
            }

        } catch (err) {
            alert.error('An error occurred while fetching therapy consultation data.');
        }
    };

    const handleOnChange = (e) => {
        const value = e.target.value;
        const key = e.target.name
        setData((currentstate) => ({
            ...currentstate,
            [key]: value,
        }))
    };

    const handleUpdate = async () => {
        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");
        const id = data.id
        const payload = {
            therapy_unit: data.therapy_unit,
            therapy_requirement: data.therapy_requirement,
            therapy_type: data.therapy_type,
            therapy_dosage: data.therapy_dosage,
            therapy_status: true
        };

        try {
            const currentRes = await axios.put(`${APIURL}/api/v1/patient/therapy-consultation/?therapy_id=${id}`, payload, {
                headers: {
                    Authorization: "Token " + str,
                    "Content-Type": "application/json",
                }
            });

            if (currentRes.data.status === "success") {
                alert.success(currentRes.data.message);
                therapy()
            } else {
                alert.error(currentRes.data.message);
            }

        } catch (err) {
            alert.error('An error occurred while updating therapy consultation data.');
        }
    }

    const onClose = () => {
        setShow(false);
    };

    return (
        <div className='therapy-container'>
            {(selected === "current") ?
                <>
                    <div className='therapy-head-container' style={{ justifyContent: 'space-between' }}>
                        <label><b>Upcoming Consultation:</b></label>
                        <div style={{ display: 'flex' }}>
                            <button onClick={() => navigate("/tilt", {
                                state: { id: id, therapy_id: data.id, mob: mobile || ' ', inpatient: inpatient, appt: (data === '' || appt_status === 'pending') ? true : false },
                            })}>Tilt Table</button>
                            <button onClick={() => navigate("/assessment", {
                                state: { id: id, therapy_id: data.id, mob: mobile || ' ', inpatient: inpatient, appt: (data === '' || appt_status === 'pending') ? true : false },
                            })}>Assessment</button>
                            <button onClick={() => setSelected("addnew")}>Follow up +</button>
                            <button onClick={() => setShow(true)}>History</button>
                        </div>
                    </div >
                    <div className='therapy-body-container'>
                        <div className='therapy-input-container'>
                            <div className='therapyinput-container col-6'>
                                <input className='therapy-input'
                                    style={{ textTransform: 'capitalize' }}
                                    name="doctor_name"
                                    placeholder='Name'
                                    value={name && name}
                                    disabled
                                />
                            </div>
                            <div className='therapyinput-container col-6'>
                                <input className='therapy-input'
                                    type="date"
                                    name="date"
                                    value={data.date}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className='therapy-input-container' style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className='col-12' style={{ padding: 0, display: 'flex', gap: '8px', flexDirection: 'row' }}>
                                <div className={`therapyinput-container ${showCustomInput ? 'col-3' : 'col-6'}`} >
                                    <label >Therapy type<span style={{ color: 'red' }}>*</span></label>
                                    <select
                                        className='therapy-input'
                                        value=""
                                        onChange={(e) => {
                                            if (e.target.value === 'custom') {
                                                setShowCustomInput(true);
                                            } else if (e.target.value) {
                                                handleTherapySelection(e.target.value);
                                            }
                                        }}
                                        disabled={data.date !== today}
                                    >
                                        <option value="">Select Therapy</option>
                                        {therapyOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                        <option value="custom">+ Add Custom Therapy</option>
                                    </select>
                                </div>
                                {showCustomInput && (
                                    <div className="therapyinput-container col-3">
                                        <label >Therapy type<span style={{ color: 'red' }}>*</span></label>
                                        <div className="custom-therapy-input" style={{ padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <input
                                                type="text"
                                                value={customTherapy}
                                                onChange={(e) => setCustomTherapy(e.target.value)}
                                                placeholder="Enter custom therapy"
                                                className="therapy-input"
                                            />
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <button
                                                    type="button"
                                                    onClick={handleCustomTherapyAdd}
                                                    style={{
                                                        flex: 1,
                                                        padding: '4px 8px',
                                                        backgroundColor: 'rgb(60, 104, 158)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Add
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setShowCustomInput(false);
                                                        setCustomTherapy('');
                                                    }}
                                                    style={{
                                                        flex: 1,
                                                        padding: '4px 8px',
                                                        backgroundColor: '#6c757d',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedTherapies.length > 0 && (
                                    <div className="selected-therapies col-6">
                                        <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                                            Selected Therapies:
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                            {selectedTherapies.map((therapy, index) => (
                                                <span
                                                    key={index}
                                                    style={{
                                                        backgroundColor: '#e9ecef',
                                                        padding: '2px 6px',
                                                        borderRadius: '12px',
                                                        fontSize: '15px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}
                                                >
                                                    {getDisplayLabel(therapy)}
                                                    {data.date === today && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeTherapy(therapy)}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                color: '#dc3545',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                padding: '0',
                                                                lineHeight: '1'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    )}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='therapy-input-container'>
                                <div className='therapyinput-container col-6'>
                                    <label>Requirement mode<span style={{ color: 'red' }}>*</span></label>
                                    <input className='therapy-input'
                                        type="text"
                                        name="therapy_requirement"
                                        value={data.therapy_requirement}
                                        placeholder='Requirement mode of therapy'
                                        onChange={handleOnChange}
                                        disabled={data.date !== today}
                                    />
                                </div>
                                <div className='therapyinput-container col-6'>
                                    <label>Therapi unit</label>
                                    <input
                                        className='therapy-input'
                                        type="text"
                                        name="therapy_unit"
                                        value={data.therapy_unit}
                                        placeholder='Unit number'
                                        onChange={handleOnChange}
                                        disabled={data.date !== today}
                                    />
                                </div>
                            </div>
                            <div className='therapy-input-container'>
                                <div className='therapyinput-container col-6'>
                                    <label>Dosage</label>
                                    <input
                                        className='therapy-input'
                                        type="text"
                                        name="therapy_dosage"
                                        value={data.therapy_dosage}
                                        placeholder='Dosage'
                                        onChange={handleOnChange}
                                        disabled={data.date !== today}
                                    />
                                </div>
                            </div>
                        </div>
                        <div><button disabled={data.date !== today || !data.therapy_requirement || appt_status === "pending"} onClick={() => handleUpdate()} className='therapy-button'>Update</button></div>
                    </div>
                </> : selected === 'addnew' ?
                    <AddTherapy selected={selected} setSelected={setSelected} patientId={id} name={name} />
                    : (selected === 'current' && data === '') ? <label className='nodata' style={{ marginTop: '14.5%' }}>No Appointment scheduled!!</label> : ''
            }
            {
                show && (
                    <ShowHistory patientId={id} onHide={onClose} />
                )
            }
        </div >
    )
}

export default Therapy